module.exports = __webpack_public_path__ + "files/abe20a833f50dbf526f98a14cace92c3.png";